/**
 * 快速打印标签
 */

export default {
  // 快速打印标签展示历史打印件数序号 202511101629492406776
  printbq_show_history_print_num: ['88114'],
}
